import React, { useEffect, useRef, useState } from 'react';
import { useViewlogies } from 'context';
import { hexToRGBA } from 'utils';
import './mobileFooter.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/free-regular-svg-icons';
import Footer from 'components/Footer';

const MobileFooter = () => {
    const {
        event: { color },
    } = useViewlogies();

    const [showFooter, setShowFooter] = useState(true);
    // const lastScrollY = useRef(0);
    const timeoutRef = useRef(null);

    // const handleScroll = () => {
    //     const currentScrollY = window.scrollY;
    //     if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
    //         setShowFooter(false);
    //     } else {
    //         setShowFooter(true);
    //     }
    //     lastScrollY.current = currentScrollY;
    // };

    // useEffect(() => {
    //     window.addEventListener('scroll', handleScroll);
    //     return () => window.removeEventListener('scroll', handleScroll);
    // }, []);

    const handleScroll = () => {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;

        const distanceFromBottom = docHeight - (scrollY + windowHeight);

        // Always show footer if within 50px of bottom
        if (distanceFromBottom <= 50) {
            setShowFooter(true);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            return;
        }

        // Show footer during scroll
        setShowFooter(true);

        // Reset hide timer
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setShowFooter(false);
        }, 500);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <>
            <div
                className={`mobile-footer ${showFooter ? 'seen' : 'unseen'}`}
                style={{ ['--topbar-color']: hexToRGBA(color, 0.25) }}
            >
                {/* ***MOVE TO BOTTOM OF PAGE*/}
                <div className="nav-footer">
                    <Footer />
                </div>
            </div>
            <div className="mobile-footer-spacing"></div>
        </>
    );
};

export default MobileFooter;
